import { SVGProps } from 'react';

export const ArrowToRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='10'
    height='9'
    viewBox='0 0 10 9'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.48484 0.484835C5.63128 0.338388 5.86872 0.338388 6.01516 0.484835L9.76517 4.23484C9.83549 4.30516 9.875 4.40054 9.875 4.5C9.875 4.59946 9.83549 4.69484 9.76517 4.76516L6.01516 8.51517C5.86872 8.66161 5.63128 8.66161 5.48483 8.51517C5.33839 8.36872 5.33839 8.13128 5.48483 7.98483L8.59467 4.875H0.5C0.292893 4.875 0.125 4.70711 0.125 4.5C0.125 4.29289 0.292893 4.125 0.5 4.125H8.59467L5.48484 1.01517C5.33839 0.868718 5.33839 0.631282 5.48484 0.484835Z'
    />
  </svg>
);
